import { unstable_cache } from 'next/cache'
import getEnvironment from './getEnvironment'

export const getMeta = async (locale = 'th', hospital) => {
  const safeLocale = locale || 'th'
  const safeHospital = hospital || ''
  if (!safeHospital || safeHospital.length <= 2 || safeLocale.includes('.')) {
    // if locale contains sw.js, return
    return {
      metaInfo: null,
      center_groups: [],
      centers: [],
      taxonomies: null,
      settings: null,
    }
  }

  const baseURL = (process.env.NEXT_PUBLIC_BASE_API_URL || '').replace(
    '/api',
    ''
  )
  const metaBaseURL = `${baseURL}/backend/meta/index.php`
  let url = `${metaBaseURL}?locale=${safeLocale}&hospital_slug=${safeHospital}`
  console.log('🌐 Fetching meta from:', '\x1b[36m' + url + '\x1b[0m')

  try {
    const res = await fetch(url)
    const data = await res.json()
    // Test mode
    if (
      data?.meta_info?.activate_test_mode &&
      getEnvironment() !== 'production' &&
      safeHospital === 'group'
    ) {
      return await getMeta(safeLocale, 'group-test')
    }
    return data
  } catch (error) {
    console.error('Error fetching meta:', error)
    return null
  }
}

export const getMetaCached = unstable_cache(
  async (locale = 'th', hospital) => {
    return await getMeta(locale, hospital)
  },
  ['getMeta'],
  { revalidate: 600 }
)

export default getMetaCached
